import { create } from 'zustand';
import { authAPI } from '../services/api';

interface UserInfo {
  id: number;
  username: string;
  is_admin: boolean;
  monthly_cost_limit: number | null;
  is_active: boolean;
}

interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setupRequired: boolean;
  user: UserInfo | null;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
  checkAuth: () => Promise<void>;
  fetchUser: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  token: localStorage.getItem('token'),
  isAuthenticated: !!localStorage.getItem('token'),
  isLoading: true,
  setupRequired: false,
  user: null,

  login: async (username: string, password: string) => {
    const response = await authAPI.login(username, password);
    const { access_token } = response.data;
    localStorage.setItem('token', access_token);
    set({ token: access_token, isAuthenticated: true });
    // Fetch user info after login
    await get().fetchUser();
  },

  logout: () => {
    localStorage.removeItem('token');
    set({ token: null, isAuthenticated: false, user: null });
  },

  fetchUser: async () => {
    try {
      const response = await authAPI.me();
      set({ user: response.data });
    } catch (error) {
      set({ user: null });
    }
  },

  checkAuth: async () => {
    try {
      const response = await authAPI.status();
      const { setup_required, ready } = response.data;

      if (setup_required) {
        set({ isLoading: false, setupRequired: true, isAuthenticated: false, user: null });
        return;
      }

      const token = localStorage.getItem('token');
      const isAuthenticated = !!token && ready;

      set({
        isLoading: false,
        setupRequired: false,
        isAuthenticated,
      });

      // Fetch user info if authenticated
      if (isAuthenticated) {
        await get().fetchUser();
      }
    } catch (error) {
      set({ isLoading: false, isAuthenticated: false, user: null });
    }
  },
}));
